<template>
  <div>
    <el-button @click="dialogVisible = true">雪碧图设置</el-button>
    <el-dialog
      :visible.sync="dialogVisible"
      @close="closeDialog"
      @open="openDialog"
      title="雪碧图设置"
      width="1200px"
    >
      <div class="url-wrap">
        <span class="url-text">URL：</span>
        <upload
          :data="{ isSprite: true, category: 'coin-sprite' }"
          :value="spriteUrl"
          class="upload"
          @change="handleUrlChanged"
        ></upload>
        <!-- <img :src="spriteUrl" alt="" ref="img"> -->
      </div>
      <div class="pre-logos">
        <div v-for="(logoY, index) in preLogos" :key="logoY">
          <div class="logo">
            <div>
              <span
                class="logo-img"
                :style="{
                  'background-image': `url(${spriteUrl})`,
                  'background-position': `${0}px ${logoY}px`
                }"
              ></span>
            </div>
          </div>
          {{ index }}
        </div>
      </div>
      <el-table :data="logoInfo">
        <el-table-column label="币种">
          <template slot-scope="scope">
            <div class="logo">
              <span
                class="logo-img"
                :style="{
                  'background-image': `url(${spriteUrl})`,
                  'background-position': `${scope.row.positionX}px ${
                    scope.row.positionY
                  }px`
                }"
              ></span>
              {{ scope.row.coinType }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="坐标 X">
          <template slot-scope="scope">
            <el-input-number
              disabled
              :value="scope.row.positionX"
              @input="
                handlePositionChange(scope.row.coinType, 'positionX', $event)
              "
              controls-position="right"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="坐标 Y">
          <template slot-scope="scope">
            <el-input-number
              disabled
              :value="scope.row.positionY"
              @input="
                handlePositionChange(scope.row.coinType, 'positionY', $event)
              "
              controls-position="right"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="编号">
          <template slot-scope="scope">
            <el-input
              :value="nos[scope.row.coinType]"
              @input="handleNosChange(scope.row.coinType, $event)"
              controls-position="right"
            ></el-input>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Upload from 'components/upload';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'CurrencySprite',
  components: {
    Upload
  },
  data() {
    return {
      imageHeight: 0,
      dialogVisible: false
    };
  },
  computed: {
    ...mapState('currencySetting', ['logoInfo', 'spriteUrl']),
    preLogos() {
      const logosYs = [];
      let temp = this.imageHeight;
      while (temp > 0) {
        logosYs.push(temp);
        temp -= 32;
      }
      return logosYs;
    },
    nos() {
      return this.logoInfo.reduce((obj, logo) => {
        return { ...obj, [logo.coinType]: logo.positionY / -32 };
      }, {});
    }
  },
  watch: {
    spriteUrl: {
      handler(val) {
        this.imageHeight = 0;
        const image = new Image();
        const that = this;
        image.addEventListener('load', function() {
          if (!this.height) return;
          const slope = this.width / 32;
          that.imageHeight = this.height / slope;
        });
        image.src = val;
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('currencySetting', ['getLogoInfo', 'updateLogoInfo']),
    ...mapMutations('currencySetting', ['setSpriteUrl', 'setLogoInfo']),
    handleUrlChanged(url) {
      this.setSpriteUrl(url);
    },
    handlePositionChange(coinType, position, value) {
      this.setLogoInfo(
        this.logoInfo.map(item => {
          return item.coinType === coinType
            ? {
                ...item,
                [position]: value ? Number(value) : 0
              }
            : item;
        })
      );
    },
    handleNosChange(coinType, value) {
      this.setLogoInfo(
        this.logoInfo.map(item => {
          return item.coinType === coinType
            ? {
                ...item,
                positionX: 0,
                positionY: Number(value) * -32
              }
            : item;
        })
      );
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    openDialog() {
      this.getLogoInfo();
    },
    handleSave() {
      this.updateLogoInfo({
        coinLogoInfoList: this.logoInfo,
        logoUrl: this.spriteUrl
      }).then(() => {
        this.$message.success('保存成功！');
        this.closeDialog();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.pre-logos {
  display: flex;
  flex-wrap: wrap;
  width: 972px;
  margin: auto;
  & > div {
    border: 1px solid #f2f2f2;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
      .logo-img {
        margin: 0;
      }
    }
  }
}
.url-wrap {
  display: flex;
  align-items: flex-start;
  padding-bottom: 10px;

  .url-text {
    line-height: 40px;
    margin-right: 8px;
  }

  .upload {
    flex: 1;
  }
}

.logo {
  display: flex;
  align-items: center;

  .logo-img {
    margin-right: 8px;
    display: inline-block;
    width: 32px;
    height: 32px;
    background-size: 32px;
  }
}
</style>
